module.exports = __webpack_public_path__ + "static/media/QMILogo2020.eccd8ac6.svg";